var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Contents"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contents",
    clipPath: "url(#clip-Contents)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Folder_Play",
    "data-name": "Folder Play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M25.856,0H5.289A2.354,2.354,0,0,0,2.938,2.351V3.526H2.351A2.354,2.354,0,0,0,0,5.876v14.1a2.354,2.354,0,0,0,2.351,2.351H4.114a.588.588,0,0,0,0-1.175H2.351A1.176,1.176,0,0,1,1.175,19.98V5.876A1.176,1.176,0,0,1,2.351,4.7H8.38A1.174,1.174,0,0,1,9.4,5.293L10.566,7.33a2.938,2.938,0,0,0,2.55,1.484h9.214A1.176,1.176,0,0,1,23.506,9.99v9.99a2.334,2.334,0,0,0,.316,1.175H20.568a.588.588,0,0,0,0,1.175h5.289a2.353,2.353,0,0,0,2.351-2.351V2.351A2.353,2.353,0,0,0,25.856,0Zm1.175,19.98a1.175,1.175,0,0,1-2.351,0V9.99a2.353,2.353,0,0,0-2.351-2.351H13.116a1.761,1.761,0,0,1-1.529-.892L10.418,4.71A2.351,2.351,0,0,0,8.38,3.526H4.114V2.351A1.176,1.176,0,0,1,5.289,1.175H25.856a1.176,1.176,0,0,1,1.175,1.175Z",
    fill: "#2591ce",
    stroke: "#2591ce",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M16.464,26a6.464,6.464,0,1,0,6.464,6.464A6.464,6.464,0,0,0,16.464,26Zm0,11.753a5.289,5.289,0,1,1,5.289-5.289A5.289,5.289,0,0,1,16.464,37.753Z",
    transform: "translate(-4.124 -10.721)",
    fill: "#2591ce",
    stroke: "#2591ce",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M21.993,34.428l-4.114-2.351a.588.588,0,0,0-.879.51v4.7a.588.588,0,0,0,.879.51l4.114-2.351a.588.588,0,0,0,0-1.02Zm-3.817,1.848V33.6l2.341,1.338Z",
    transform: "translate(-7.01 -13.195)",
    fill: "#2591ce"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContents);
export default __webpack_public_path__ + "static/media/Contents.1066eb9d.svg";
export { ForwardRef as ReactComponent };